export enum OptionalFollowUpConsultDiagnosis {
    droge_ogen = 'droge_ogen',
    glaucoom = 'glaucoom',
    glaucoom_ja = 'glaucoom_ja',
    glaucoom_suspect = 'glaucoom_suspect',
}
